export enum ColumnType {
  Description = 'description',
  Image = 'image',
  Simple = 'simple',
  IconBox = 'iconBox',
  ImageWithBox = 'imageWithBox',
}
